export const frequencyBands = ["low", "low-mid", "mid", "high"];
export const stereoPresences = ["narrow", "medium", "wide"];
export const depths = ["front", "middle", "back"];
export const shapes = ["transient", "sustained"];
